export const API_BASE_URI = process.env.API_BASE_URI;
export const SITE_ORIGIN = process.env.SITE_ORIGIN;
